import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateVoucherMutation } from "@modules/vouchers/services/mutations";
import { VoucherFormValues, voucherSchema } from "@modules/vouchers/validations";
import { listVouchersQueryKey } from "@modules/vouchers/services/queries/listVouchers/query";

export function useCreateVoucherModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<VoucherFormValues>({
    resolver: zodResolver(voucherSchema()),
    defaultValues: {
      active: true,
    },
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateVoucherMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listVouchersQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("voucher_batch_admin.success.create"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
